import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, viewMode, productType, selectedCollectionName }) => {
  if (products.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600">Aucun produit trouvé.</p>
      </div>
    );
  }

  return (
    <div className={`${
      viewMode === 'grid' 
        ? 'grid grid-cols-4 gap-6' 
        : 'flex flex-col gap-4'
    }`}>
      {products.map((product) => (
        <ProductCard 
          key={product.id} 
          product={product} 
          viewMode={viewMode} 
          productType={productType}
          collectionName={selectedCollectionName}
        />
      ))}
    </div>
  );
};

export default ProductGrid;